@if (isEditMode) {
  <div class="table-content" title="{{cellValue}}">
    <input class="form-control" [(ngModel)]="cellValue" (blur)="blurAction()" autofocus>
  </div>
}

@if (!isEditMode) {
  <div class="table-content" title="{{cellValue}}">
    {{cellValue}}
  </div>
}